import React, { useState } from 'react';

import OtpInput from './OtpInputBoxes';
import {
  ErrorMessage,
  OTPFieldLabel,
  OtpInputContainer
} from './styledComponents';

interface OtpInputControllerProps {
  onChange: (code: string) => void;
  otpValue: string;
  isError?: boolean;
  label?: string;
  errorMessage?: string;
  shouldAutoFocus: boolean;
  isDisabled?: boolean;
  inputClassName?: string;
  inputFocusClassName?: string;
  errorClassName?: string;
  t: any;
  showToast?: () => void;
  apiStatus?: number;
  labelStyles?: string;
  otpContainerStyles?: string;
  errorMessageStyles?: string;
  numInputs?: number;
  onBlur?: (e: any) => void;
  isFocus?: boolean;
}

export default function OtpInputController({
  onChange,
  otpValue,
  isError,
  label,
  errorMessage,
  shouldAutoFocus,
  isDisabled,
  inputClassName,
  inputFocusClassName,
  errorClassName,
  showToast,
  t,
  apiStatus,
  otpContainerStyles,
  labelStyles,
  errorMessageStyles,
  numInputs,
  onBlur,
  isFocus
}: OtpInputControllerProps) {
  return (
    <OtpInputContainer isError={isError} css={otpContainerStyles}>
      <OTPFieldLabel css={labelStyles} className="otpFieldLabelClassName">
        {label}
      </OTPFieldLabel>
      <OtpInput
        value={otpValue}
        onChange={onChange}
        numInputs={numInputs ? numInputs : 6}
        hasErrored={isError && !isFocus}
        inputStyle={inputClassName ? inputClassName : 'otp-input-container'}
        focusStyle={
          inputFocusClassName ? inputFocusClassName : 'otp-input-focus-style'
        }
        errorStyle={errorClassName ? errorClassName : 'otp-input-error-style'}
        shouldAutoFocus={shouldAutoFocus}
        isDisabled={isDisabled}
        showToast={showToast}
        t={t}
        apiStatus={apiStatus}
        onBlur={onBlur}
        containerStyle={'otp-input-box-containers'}
      />
      {!isFocus && errorMessage ? (
        <ErrorMessage css={errorMessageStyles}>{errorMessage}</ErrorMessage>
      ) : (
        <ErrorMessage css={errorMessageStyles}></ErrorMessage>
      )}
    </OtpInputContainer>
  );
}
